export default __webpack_public_path__ + "static/media/back_prize.3165c2ce.png";